<template>
<div>
   <div class="container-fluid">
    <div>
           <!--inicio-->
                <b-card border-variant="secondary"  header-text-variant="black" align="center" v-if="!verCrear">
                    <div slot="header">
                        <h3>Registro de Mercadería</h3>
                        <div align="left">
                        <b-button variant="success" @click="listaver()">
                            Ver Lista
                        </b-button>
                        </div>
                    </div>                
                  <div class="contenedor">
                    <b-row>
                        <b-col cols="2" class="mt-2">
                            <div>
                                <select class="custom-select mr-sm-2 input-placedark input-dark"  v-model="tipoDocumento2">
                                    <option :value="tipodocumento2.tipo" v-for="tipodocumento2 in documentosIdentidad" v-bind:key="tipodocumento2.tipo">
                                {{ tipodocumento2.nombre }}
                            </option>
                                </select>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="2" class="mt-2">
                            <div>
                                <b-input-group>
                                    <b-form-input placeholder="Documento" :disabled="docum" maxlength="11" v-model="receptor.numero" @change="pitcherReceiver(1)"></b-form-input>
                                      <b-input-group-text slot="append">                                                       
                                            <button class="btn btn-success btn-sm sinresultados" @click="closeList()" ><i class="fas fa-arrow-up"></i></button>                                                                       
                                    </b-input-group-text>
                                     <template v-if="cargandoreceptor">
                                        <b-list-group class="searcher-field">
                                        <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                                        </b-list-group>
                                    </template>
                                     <b-list-group v-if="listarec" class="searcher-field">
                                        <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                                        <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">
                                            {{item.idReceptor + ' - ' + item.razonSocial}}
                                        </b-list-group-item>
                                        </template>
                                    </b-list-group>
                                </b-input-group>
                            </div>
                        </b-col>
                         <b-col cols="12" sm="5" md="5" lg="4" xl="3" class="mt-2">
                            <div>
                                <b-input-group>
                                    <b-form-input placeholder="Razon Social" type="text" @input="pitcherReceiver(2)" v-model="receptor.razonSocial" :value="receptor.razonSocial"></b-form-input>
                                </b-input-group>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="3" class="mt-2">
                            <div>
                                <b-form-input type="text"  placeholder="Dirección " v-model="receptor.direccion" :disabled="direc"></b-form-input>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="1" class="mt-2">
                            <div>
                                  <b-form-input v-model="serie" placeholder="Serie" style="width:120%" title="Serie Doc."></b-form-input>                        
                            </div>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="1" class="mt-2">
                            <b-form-input  v-model="numerodoc" maxlength="7" placeholder="Número." style="width:110%" title="Num. Doc"></b-form-input>
                        </b-col>
                    </b-row>
                    <!--  -->
                    <b-row>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="4" class="mt-4">
                            <div>
                                <b-input-group>
                                    <b-input-group-prepend is-text >
                                    <i class="fas fa-boxes"></i>
                                    </b-input-group-prepend>
                                    <b-form-input  placeholder="Almacen Principal" disabled></b-form-input>
                                </b-input-group>
                            </div>   
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="2" class="mt-4">
                            <div>
                               <datepicker class="input-placedark input-dark"  v-model="fechaIngreso" :language="es" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha Ingreso mercaderia"></datepicker>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="2" class="mt-4">
                             <datepicker class="input-placedark input-dark" v-model="fechavencimiento" :language="es" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha Vencimiento"></datepicker>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="2" class="mt-4 ">
                            <datepicker class="input-placedark input-dark" v-model="fechaemision" :language="es" :format="customFormatter" :bootstrap-styling="true"  placeholder="Fecha Factura"></datepicker>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="1" class="mt-4">
                            <b-form-select v-model="selected" :options="options" style="width:120%" title="Tipo Documento"></b-form-select>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="1" class="mt-4"  >
                             <select class="custom-select mr-sm-2 input-placedark input-dark"  v-model="moneda" style="width:110%" title="Tipo Moneda">
                                <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                    {{ moneda.descripcion }}
                                </option>
                        </select>
                        </b-col>
                    </b-row>
                    <!--  -->
                    <b-row>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="4" class="mt-4">
                            <b-input-group>
                            <b-form-input placeholder="Ingrese Producto" maxlength="500" v-model="descripcion" @input="getReceiversDescription" type="text"></b-form-input>
                            <b-input-group-text slot="append">
                                <button class="btn btn-warning btn-sm sinresultados" @click="cerrarresultados"><i class="fa fa-times"></i></button>
                            </b-input-group-text>
                            </b-input-group>
                            <template v-if="cargandoDescription">
                                <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                            </template>
                            <b-list-group v-if="listades" class="searcher-fieldPro">
                                <b-list-group-item v-if="nodescription">No hay Receptores con ese número</b-list-group-item>
                                <template v-for="(item, index) in listaDescription">
                                <b-list-group-item :key="index" @click="setReceiverDescription(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion +'---Categoria: ' + idCategoria +' --- Precio: ' + item.precioUnitario}}</b-list-group-item>
                                </template>
                            </b-list-group>
                        </b-col>
                         <b-col cols="12" sm="5" md="5" lg="4" xl="2" class="mt-4">
                            <select class="custom-select input-placedark input-dark" v-model="unidadMedidaCantidad">
                                <option :value="unidad.codigo" v-for="unidad in unidades" v-bind:key="unidad.id">
                                    {{unidad.descripcion}}
                                </option>
                            </select>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="4" xl="2" class="mt-4">
                            <b-form-input type="number" placeholder="Cantidad" maxlength="7" v-model="cantidadStock" title="Cantidad Producto" style="width:105%"></b-form-input>
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="2" xl="2" class="mt-4">
                            <b-form-input type="number" @keyup.enter="addItem" placeholder="Precio Unitario (IGV)" v-model="precioUnitarioIGV" title="Precio con IGV" style="width:105%"></b-form-input>
                        </b-col>  
                        <b-col cols="12" sm="5" md="5" lg="4" xl="2" class="mt-4">
                            <template v-if="!setUpdateItem">
                                <b-button style="width:100%" variant="success" @click="addItem()">
                                    <i class="fa fa-plus"></i> Agregar
                                </b-button>
                            <!-- <vue-snotify></vue-snotify> -->
                            </template>
                            <template v-else>
                                <button style="width:100%" class="btn btn-warning" @click="executeUpdate()">
                                    <i class="fa fa-plus"></i> Actualizar
                                </button>
                            </template>                            
                        </b-col> 
                        <import :item="item" :itemsEx="itemsEx" :action="action" @totalitems="totalitems"></import>                   
                    </b-row>
                    <b-row>           
                        <b-col cols="12" sm="5" md="5" lg="2" xl="2" class="mt-3">
                            <template v-if="file == null">
                                <div class="wrapper">  
                                    <div class="file-upload">
                                        <i class="fas fa-upload mr-1"></i>
                                        Items
                                        <b-form-file v-model="file" plain></b-form-file>
                                    </div>                                  
                                </div>
                            </template>
                            <template v-else>
                                <b-button title="Items Listos" variant="success" @click="subirItems()">Importar <i class="fas fa-check-circle"></i></b-button>
                            </template> 
                        </b-col>
                        <b-col cols="12" sm="5" md="5" lg="2" xl="2" class="mt-3">
                            <template v-if="rechazados !=''">
                                <div class="mt-2" style="width:120%">
                                    <b-button @click="mostrarItemsRechazados()" variant="outline-danger">Items no registrados</b-button>
                                    <b-button href="http://telemovildata.com/producto/ingreso_de_stock_producto.xlsx" variant="outline-success" style="float:right">Ejemp. Excel</b-button>
                                </div>
                            </template> 
                            <template v-else-if="rechazados == ''">
                               <b-button href="http://telemovildata.com/producto/ingreso_de_stock_producto.xlsx" class="mt-1" variant="outline-success">Ejemp. Excel</b-button>
                            </template>   
                        </b-col>
                        <b-modal  v-model="itemsRechazados">
                            <b-card border-variant="secondary" header-text-variant="black" align="center">
                                <div slot="header">
                                    <h3>Items Rechazados</h3>
                                </div> 
                                <!-- tabla rechazados -->
                                <b-table
                                outlined
                                :items="rechazados"
                                :fields="rechazados_fields">
                                 <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                                </b-table>
                                <i>Los items rechazados, son Items que no subieron al listado por no estar registrados en el Sistema. <br> (Verifique el el codigo del producto este registrado o bien escrito)</i>
                            </b-card>
                        </b-modal>
                    </b-row>
                    <!-- tabla---> 
                    <br>
                       <b-col>
                            <b-table 
                            small
                            responsive
                            :items="items"
                            :fields="entradas_fields"
                            head-variant="light"
                            :outlined="outlined"
                            >
                            <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                            <template slot="acciones" slot-scope="row">
                                <b-row class="pl-3">
                                    <button class="btn btn-sm btn-group btn-outline-primary"
                                        @click.prevent="updateItem(row.index, row.item)">
                                        <i class="fa fa-edit primary"></i>
                                    </button>
                                    <button class="btn btn-sm btn-group btn-outline-danger"
                                        @click.prevent="deleteItem(row.index)">
                                        <i class="fa fa-trash danger"></i>
                                    </button> 
                                </b-row>
                            </template>
                            </b-table>
                        </b-col>
                        <hr> 
                            <b-row>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                                <div>
                                 <b-form-textarea
                                        id="textarea"
                                        v-model="observaciones"
                                        placeholder="Alguna Observación de Ingreso..."
                                        rows="3"
                                        max-rows="6"
                                        maxlength="50"
                                        limi
                                    ></b-form-textarea>                                  
                                </div>
                                </b-col>
                                <template v-if="!tag2">
                                <b-col cols="12" sm="5" md="5" lg="4" xl="2">
                                <div>
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="motivoEdicion"
                                        placeholder="Motivo de Edición..."
                                        rows="3"
                                        max-rows="6"
                                        maxlength="50"
                                    ></b-form-textarea>                                  
                                </div>
                            </b-col>
                            <b-col cols="12" sm="5" md="5" lg="4" xl="2">
                                <b-form-select v-model="selected_stock" :options="options_stock" size="sm"></b-form-select>
                            </b-col>
                            <b-col cols="12" sm="5" md="5" lg="4" xl="2">
                                <div>
                                <datepicker class="input-placedark input-dark"  v-model="fecEdicion" :language="es" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha Edicíon" title="Fecha de Modificación"></datepicker>
                                </div>
                            </b-col>
                            </template>
                            </b-row>   
                        <br>
                        <b-row>
                            <b-col  cols="12" sm="5" md="5" lg="4" xl="2">
                               <h5><b-badge variant="secondary" style="color:#5c6873">T.bruto</b-badge></h5>
                                <div>{{ moneda.simbolo }} {{ valortotal() }}</div>         
                            </b-col>
                            <b-col  cols="12" sm="5" md="5" lg="4" xl="2">
                                <h5><b-badge variant="secondary"  style="color:#5c6873">T.dsctos</b-badge></h5>
                                <div>{{ moneda.simbolo }}</div>         
                            </b-col>
                            <b-col  cols="12" sm="5" md="5" lg="4" xl="2">
                                <h5><b-badge variant="secondary"  style="color:#5c6873">Subtotal</b-badge></h5>
                                <div>{{ moneda.simbolo }} {{ valortotal() }}</div>          
                            </b-col>
                            <b-col  cols="12" sm="5" md="5" lg="4" xl="2">
                                <h5><b-badge variant="secondary"  style="color:#5c6873">IGV</b-badge></h5>
                                <div>{{ moneda.simbolo }} {{ totalesIGV() }}</div>        
                            </b-col>
                            <b-col  cols="12" sm="5" md="5" lg="4" xl="2">
                                <h5><b-badge variant="secondary" style="color:#5c6873">Total</b-badge></h5>
                               <div>{{ moneda.simbolo }} {{  total() }}</div>    
                            </b-col>
                            <b-col cols="12" sm="5" md="5" lg="4" xl="2">
                               <template v-if="tag2">
                                <b-button  variant="success" @click="validarMercaderia()">Guardar
                                     <i class="far fa-save"></i>
                                </b-button>
                                </template>
                                <template v-else>               
                                <b-button  variant="warning" @click="actualizarEntrada()">
                                    Editar
                                </b-button>
                                 <b-button  variant="dark" @click="CancelarEditEntrada()">
                                    Cancelar
                                </b-button>
                               </template>
                            </b-col>
                        </b-row>                                   
                  </div>
                </b-card>
            <!--Inicio Listado-->
    <b-card v-else border-variant="secondary"  header="Listado de Mercaderia" header-text-variant="black" align="center">
        <div slot="header">
            <h3>Listado de Mercadería</h3>
            <div align="left">
                <b-button variant="success" @click="crear()">
                    Agregar Mercaderia
                    <i class="fa fa-plus"></i> 
                </b-button>
            </div>
        </div>
        <div v-if="cargando">
            <div class="row">
            <div class="col-md-12 text-center">
            <h3>Cargando<i class="fa fa-spin fa-spinner"></i></h3>
            </div>
            </div>
        </div>
        <div v-else>
            <template>
                <div>
                    <b-table small head-variant="light" responsive :items="listado" :fields="listado_fields"  :outlined="outlined" >
                        <template slot="acciones" slot-scope="row" >   
                            <b-row class="">
                                <b-button-group>
                                <button  @click="row.toggleDetails" type="button" class="btn btn-sm" title="Mas opciones">
                                    <template v-if="!row.detailsShowing">
                                        <i class="fa fa-plus"></i> 
                                    </template>
                                    <template v-else>
                                        <i class="fa fa-minus"></i>
                                     </template>
                                </button>
                                <!-- <button class="btn btn-sm btn-group btn-outline-primary acciones-espacio"
                                     @click.prevent="updateEntrada(row.index, row.item)">
                                    <i class="fa fa-edit primary"></i>
                                </button> -->
                                <button class="btn btn-sm btn-group btn-outline-danger"
                                    @click.prevent="deleteEntrada(row.item.idEntrada)">
                                    <i class="fa fa-trash danger"></i>
                                </button>
                                </b-button-group>
                            </b-row>
                        </template>

                        <template slot="row-details" slot-scope="row">
                            <b-card>
                                <b-table head-variant="light" :items="row.item.entrydetail" :fields="listadoDetalle_fields" :outlined="outlined">
                                    <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                                </b-table>  
                                <div align="left">  
                                    <label style="color:red">observaciones</label> | {{row.item.observaciones}}
                                </div>
                            </b-card>
                        </template>
                    </b-table>
                    <b-row>
                        <b-col cols="12" sm="4" md="6" lg="8" xl="8">
                            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{totalList}} registros</p>
                        </b-col>
                        <b-col cols="12" sm="8" md="6" lg="4" xl="4">
                            <b-pagination
                                size="sm"
                                v-model.number="paginaActual"
                                :total-rows="totalList"
                                :per-page="limite"
                                @input="getlistado"
                                aria-controls="my-table"
                            ></b-pagination>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </div>
    </b-card>
    </div>
    <vue-snotify></vue-snotify>
   </div>
</div> 
</template>     

<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import { TipoMoneda } from '@/shared/utils'
import {es} from 'vuejs-datepicker/dist/locale'
import { UnidadMedida } from "@/shared/utils"
import { TipoAfectacion } from '@/shared/utils'
import { DocumentosIdentidad } from '@/shared/utils'
import { XlsxRead, XlsxJson, XlsxTable } from "vue-xlsx/dist/vue-xlsx.es.js"
import * as XLSX from "xlsx";
import Import from '@/components/comunes/ItemsMercaderiaExcel'
export default {
    name: 'Stock',
    components:{
        Datepicker,
        XlsxRead,
        XlsxJson,
        XlsxTable,
        Import
    },

    data: () => {
        return {
            verCrear:true,
            outlined:true,
            tabIndex:1,
            tag1:true,
            tag2:true,
            paginaActual:1,
            limite:15,
            orden:'desc',
            order:'desc',
            totalList: 0.0,
            desde: 0.0,
            hasta: 0.0,
            idEntrada:'',
            cargando:false,
            toupdatecatego:{},
            editCat:'',
            idCategoriaEditar:'',
            mostraredit:false,
            selected:1,
            options:[
                {value: 1, text:'Factura'},
                {value: 2, text:'Boleta'},
                {value: 3, text:'Guia'},
                {value: 4, text:'Otros'},
            ],
            es: es,
            indexSerie: 0,
            indexCategoria:'',
            tipodoc: '1',
            rolSeries: '',
            listaSeries: [],
            seriesCargadas: true,
            tipoMoneda: TipoMoneda,
            moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            receptor: {
                tipo: '',
                nro: '',
                razonSocial: '',
                direccion: ''
            },
            receptor: {
                numero: "",
                tipo: "6",
                razonSocial: "",
                direccion: ""
            },
            diasnopermitidos:{
                ranges:[]
            },
            fechaIngreso:'',
            fechaemision:'',
            fechavencimiento:'',
            fecEdicion:'',
            motivoEdicion:'',    
            numerodoc:'',
            adicionaldoc:null,
            totaldscto:0.0,
            serie:'',
            tipodocingreso:'',
            unidades:UnidadMedida,
            almacen:'Almacen Principal',
            observaciones:'',
            codigoProductoSunat:null,
            codigoProductoGs1:null,
            cargandoreceptor:false,
            listarec: true,
            norec: false,
            listaReceptores: [],
            direcciones: [],
            rucValid: null,
            items:[],
            entradas_fields: [
                {key: "index", label: "Item" },
                {key:'codigo',label:'CodigoPro'},
                //{key: 'codigoProductoSunat', label: 'Cod.Sunat'},
                //{key: 'codigoProductoGs1', label: '--'},
                {key: 'unidadMedida', label:'U.M'},
                {key: 'cantidad', label:'Cantidad'},
                {key: 'descripcion', label:'Descripcion'},
                // {key: 'valorUnitario', label:'Valor.Unit'},
                {key: 'valorTotal', label:'Valor Total'},
                {key: 'igv', label:'IGV'},
                {key: 'precioTotal', label:'Precio Total'},
                //{key: 'idCategoria', label:'Id.Categoria'},
                {key: 'acciones', label:'Acciones'},                
                ],
            listado: [],
            listado_fields:[  
                {key:"idEntrada",label:"Nro Ingreso"},            
                {key:"almacen",label:"Almacen"},
                {key:"rucProveedor",label:"RUC Proveedor"},
                {key:"rsProveedor",label:"Razon Social"},
                {key:"fechaIngreso",label:"Fecha Ingreso"},
                {key:"tipoDocIngreso",label:"Tipo.Doc"},
                {key:"serieDoc",label:"Serie"},
                {key:"numeroDoc",label:"Numero"},
                // {key:"observaciones",label:"Observaciones"},
                {key:"total",label:"Total"},
                {key:"acciones",label:"Acciones"},
                
            ],
            listadoDetalle_fields:[
                {key:"index",label:"Item"},
                {key:"codigo",label:"Cod.Producto"},
                {key:"unidadMedida",label:"Unidad.M"}, 
                {key:"descripcion",label:"Descripcion"},
                {key:"precioUnitario",label:"Precio Unitario"},
                {key:"cantidad",label:"Cantidad"},
                {key:"igv",label:"IGV"},
                {key:"valorTotal",label:"Valor Total"}, 

            ],
            listaCategoria:[],
            listaCategoria_fields:[
                {key:"index",label:"Indice"},
                {Key:"idCategoria",label:"Id"},
                {key:"descripcion",label:"Categoría"},
                {key:"acciones",label:"Acciones"}    
            ],
            selected_stock:1,
            options_stock: [
                { value: 1, text: 'Ingreso Stock' },
                { value: 2, text: 'Salida Stock' },
            ],
            tipoStockIngreso:'',
            descripcionCat:'',
            categoriasProdu:false,
            cargandoDescription: false,
            listades:true,
            listaDescription:[],
            sendproducto: false,
            nuevoproducto: false,
            nodescription: false,
            info: null,
            idProducto: '-',
            codigoProducto: '',
            descripcion:'',
            cantidadStock:1,
            unidadMedidaCantidad:'NIU',
            precioUnitario:0.0,
            precioTotalVenta:0.0,
            precioUnitarioIGV:'',
            igv:0.0,
            baseAfectacionIgv:'',
            valorTotal:0.0,
            valorUni:0.0,
            sumaIGV:0.0,
            sumaValor:0.0,
            precioTotal:'',
            cantidadS:'',
            precioConIgv:'',
            unidadM:'',
            description:'',
            tipoAfecta:'01',
            idCategoria:1,
            setUpdateItem: false,
            setIndex: -1,

            checkdescripcion: false,
            responsecheckdescripcion: '',
            outlined:true,
            documentosIdentidad: DocumentosIdentidad,
            tipoDocumento2:6,
            direc:true,
            docum:false,
            file: null,
            coleccion:[],
            itemsEx:[],
            action: {
                i: false,
                reset: false
            },
            item:[],
            entrada:{
                almacen:'',
                rucproveedor:'',
                rsproveedor:'',
                fechaingreso:'',
                fechaemisiondoc:'',
                fechavencimiento:'',
                tipodocingreso:'',
                seriedoc:'',
                numerodoc:'',
                moneda:'',
                adicional:{
                    tipo_igv:''
                },
                totalbruto:0.00,
                totaldscto:0.00,
                subtotal:0.00,
                igv:0.00,
                total:0.00,
                observaciones:'',
                items: [],
            },
            itemsAccepted:[],
            tipoAfectacionIgv:'',
            itemsRechazados:false,
            rechazados:[],
            rechazados_fields:[
                {key:'index', label:'Nº'},
                {key:'cantidad',label:'Cantidad'},
                {key:'codigo',label:'Codigo Producto'},
                {key:'descripcion',label:'Producto'},
                {key:'preciounitario',label:'Precio'}
            ],
            igvGlobal:null,
            unoDieciocho:1.18,
            ceroDieciocho:0.18,
            // unoUno:1.1,
            // ceroUno:0.1,
            unoUno:1.105,
            ceroUno:0.105,
        }
    },
    /*******/
    mounted(){
    this.getSeries(),
    this.tipodocumento(),
    this.tipoStock(),
    this.initDates(),
    this.getlistado(),
    this.getCategoria()
    },
    watch:{
        descripcion: function () {
            if(this.descripcion.length > 500){
                this.checkdescripcion = true
                this.responsecheckdescripcion = 'Alfanumerico de maximo 500 caracteres '
            }else if(this.descripcion.length == 0){
                this.sinresultados = false,
                this.listades = false,
                this.listaDescription = []
            }else{
                this.checkdescripcion = false
                this.responsecheckdescripcion = ''
            }
        },
        tipoDocumento2(){
            if(this.tipoDocumento2 == 0){
                this.direc = false;
                this.docum = true;
            }else{
                this.direc = true;
                this.docum = false;
            }
        },
        coleccion:function(){
            if(this.coleccion !=null){                   
                this.itemsEx = this.coleccion
                this.action.i = true                  
            }
        },
    },
    methods:{
    onChange(event) {
            this.file = event.target.files ? event.target.files[0] : null;
        },
    totalitems(value){
        this.items = value
        this.action.i = false
    },
    customFormatter: function (date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
    getSeries: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.tipodoc, {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data,
                this.rolSeries = response.data.rol,
                this.seriesCargadas = false,
                this.igvGlobal = response.data.igv
            ))
            .catch(error => {
                this.seriesCargadas = false
            })
        },
    getCategoria(){
       
            this.cargando = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/categoria/listar',{
                 token: this.$store.getters.userToken,
                 order:this.order,
                 limit:this.limite
            })
            .then(response =>(
                this.listaCategoria = response.data.data,
                this.cargando = false
            ))
            .catch(error => {
                this.cargando = true;
            })
        },
    addCategoria(){
            axios.
            post(process.env.VUE_APP_API_URL + 'productos/categoria/insertar',{
                token: this.$store.getters.userToken,
                descripcion : this.descripcionCat,
                adicional: this.adicionaldoc
            })
            .then(response =>(
                 (this.info = response.data.data),
                 this.$snotify.success(response.data.msg, "Exito"),
                 this.getCategoria(),
                 this.descripcionCat = ''
            ))
            .catch(error =>{
                this.$snotify.warning("Campo vacío")
            })
        },
    toUpdateCategoria(value, idcategoria){
                this.mostraredit = true;
                this.idCategoriaEditar = idcategoria; //obtengo el idCategoria por parametro
                this.toupdatecatego.descripcion = value;
                this.editCat = value;
        },
    actualizarCategoria(){
                axios
            .post(process.env.VUE_APP_API_URL + 'productos/categoria/actualizar',{
                 token: this.$store.getters.userToken,
                 idcategoria: this.idCategoriaEditar,
                 descripcion : this.editCat,
                 adicional: this.adicionaldoc
                })
            .then(response =>(
                (this.info = response.data.data),
                this.$snotify.success(response.data.msg, "Editado"),
                this.editCat = '',
                this.mostraredit = false,
                this.getCategoria()
            ))
            .catch(error =>{
                 this.$snotify.error(error.response.data.msg, "Error")
            });
        },
    deleteCategoria(value){
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/categoria/eliminar',{
                token: this.$store.getters.userToken,
                idcategoria: value
                })
                .then(response => {                
                    this.$snotify.success(response.data.msg, "Eliminado")
                    this.getCategoria()
                })
                .catch(response =>{
                     this.$snotify.error(error.response.data.msg, "Error")
                })
        },
    // updateEntrada(index,entradaUpdate){
    //         this.tag2 = false;
    //         let itemChange = entradaUpdate;
    //         let item = {};
    //         this.setIndex = index;
    //         this.almacen = itemChange.almacen;
    //         this.serie = itemChange.serieDoc;
    //         this.items = itemChange.entrydetail;
    //         this.observaciones = itemChange.observaciones;           
    //     },
    actualizarEntrada(){
            axios
            .post(process.env.VUE_APP_API_URL + 'ajusteinventario/ingreso',{
                token: this.$store.getters.userToken,
                almacen: this.almacen,
                serie: this.serie,
                fechaajuste: this.$moment(this.fecEdicion).format("YYYY-MM-DD HH:mm:ss"),
                moneda: this.moneda.codigo,
                motivoajuste: this.motivoEdicion,
                accion: this.tipoStockIngreso,
                adicional: this.adicionaldoc,
                total: this.total(),
                observaciones: this.observaciones,
                items: this.items
            })
            .then(response =>{
                this.$snotify.success(response.data.msg, "Almacen Editado")
            })
            .catch(response =>{
                 this.$snotify.error(error.response.data.msg, "Error")
            })
        }, 

    tipoStock(){
                let  val = this.tipoStockIngreso
                    if(this.selected_stock == 1){
                        this.tipoStockIngreso = 'Ingreso Stock'
                    }else if(this.selected_stock == 2){
                        this.tipoStockIngreso = 'Salida Stock'
                    }
                    return val;     
         },
    CancelarEditEntrada(){
            this.tag2 = true;
        },
    closeList(){
        this.cargandoreceptor = false
        this.listarec = false
        },
    pitcherReceiver: function (value) {
            if(value === 1){
            if(this.receptor.numero.length >= 3){
                setTimeout(() => this.getReceivers(), 200);
            }else if(this.receptor.numero.length <= 2){
                this.initReceptor()
                }
            }
            if(value === 2){
            if(this.receptor.razonSocial.length >= 3){
                setTimeout(() => this.getReceiversByRSocial(), 200);
            }else if(this.receptor.razonSocial.length <= 2){
                this.initReceptor()
            }
            }
        },
    getReceiversByRSocial: function () {
            if(this.receptor.razonSocial.length>=3){
                this.cargandoreceptor = true
                this.listarec = true
                this.norec = false
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros/razonsocial',{
                token: this.$store.getters.userToken, 
                q: this.receptor.razonSocial,
            })
            .then(response => (
                this.listaReceptores = response.data,
                this.cargandoreceptor = false,
                this.addReceiver(this.listaReceptores),
                this.receivercount(this.listaReceptores.length)
            ))
            .catch(error => (
                this.cargandoreceptor = false
            ))
            }else{
            this.listaReceptores = [],
            this.cargandoreceptor = false
            }
        },
    receivercountDescription: function (value) {
                if(!value)
                {
                this.nodescription = true
                }
                else
                {
                this.nodescription = false
                }
        },
        receivercount: function (value){
    if(value.length === 0)
    {
      this.$snotify.warning('No se encontró al receptor, ingrese el RUC completo ó agreguelo como nuevo cliente', 'Atención')
    }
  },
    initReceptor: function () {
            this.receptor = {
                numero:'',
                tipo:'6',
                direccion:'',
                nombre:'',
                direccionReferencia: ''
            },
            this.listaReceptores = [],
            this.cargandoreceptor = false
        },
    setReceiver: function (item) {
            this.receptor.numero = item.idReceptor,
            this.receptor.tipo = item.tipo,
            this.receptor.razonSocial = item.razonSocial,
            this.receptor.direccion = item.direccionReferencia,
            this.direcciones = item.direcciones,
            //   this.listaCorreos = item.email,
            this.listarec = false,
            this.listaReceptores = []
        },
    stateReceptorRuc (value) {
            let expreg = new RegExp('\\s|<|>|[A-Za-z]|^[3-9]|^[0]')
            if(value.length == 0){
                // this.$snotify.error('RUC Inválido','Error');
                this.rucValid = false
            } else if (expreg.test(value)) {
                this.$snotify.error('RUC Inválido','Error');
                this.rucValid = false
            } else {    
                this.rucValid = true       
            }
        },
    getReceivers: function () {
            if(this.receptor.numero.charAt(0)!=2){
                this.direc = false
            }else{
                this.direc = true
            }
            this.cargandoreceptor = true
            if(this.receptor.numero.length >= 3){ 
            this.stateReceptorRuc(this.receptor.numero)
            if(this.rucValid){
            this.listarec = true
            this.norec = false

            // lista/razonSocial
                axios
                .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                token: this.$store.getters.userToken,
                q: this.receptor.numero,
                tipoRec: '6'
                })
                .then(response => (
                this.listaReceptores = response.data,
                this.cargandoreceptor = false,
                this.addReceiver(this.listaReceptores),
                this.receivercount(this.listaReceptores.length)
                ))
                .catch(error => (
                this.listaReceptores = [],
                this.cargandoreceptor = false,
                this.listarec = false        
                // this.norec = false
                ))
            }  
            }else if(this.receptor.numero.length === 0){
            this.listaReceptores = [],
            this.cargandoreceptor = false
            }else{
            this.listaReceptores = []
            }    
        },
    addReceiver: function (value) {
            if(value.length == 0){
            this.modalCliente = true
            }else{
            this.modalCliente = false
            } 
        },
    getReceiversDescription: function () {
            this.listaDescription = []
            if(this.descripcion.length > 1 && !this.sinresultados){
            this.sinresultados = true,
            setTimeout(() => 
            this.cargandoDescription = true,
            this.listades = true,
            this.nodescription = false,
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'name',
                p: this.descripcion
            })
            .then(response => (
                this.listaDescription = response.data.response,
                this.cargandoDescription = false,
                this.sinresultados = false,
                this.receivercountDescription(this.listaDescription.length)
            ))
            .catch(error => (
                this.cargandoDescription = false,
                this.sinresultados = true,
                this.menssageErrorDescripcion(error.response.data)
            )) 
            , 200);
            }
        },
    menssageErrorDescripcion: function (value) {
            if(value.success == 0){
                this.$snotify.warning(value.msj, 'Atención')
            }
        },
    cerrarresultados: function () {
            this.listaDescription = [],
            this.listades = false
        },
    setReceiverDescription: function (item) {
        console.log(item)
                this.idProducto = item.idProducto,
                this.codigoProducto = item.codigo,
                this.descripcion = item.descripcion,
                this.codigoProductoGs1 = item.codigoProductoGs1,
                this.codigoProductoSunat = item.codigoProductoSunat,
                this.precioUnitarioIGV = item.precioUnitario
                this.unidadMedidaCantidad = item.unidadMedida
                if(item.idCategoria != ''){
                    this.indexCategoria = item.idCategoria
                }else{
                    this.indexCategoria = ''
                }
                if(item.tipoAfectacionIgv == ''){
                    this.tipoAfectacionIgv = '01'
                }else{
                    this.tipoAfectacionIgv = item.tipoAfectacionIgv
                }
                this.listades = false,
                this.listaDescription = []
        },

    sendProduct: function () {
                let producto = {}
                this.sendproducto = true
                this.nuevoproducto = true
                producto.codigo = this.codigoProducto
                producto.unidadMedida = this.unidadMedidaCantidad
                producto.descripcion = this.descripcion
                producto.precioUnitario = this.precioUnitarioIGV
                producto.tipoAfectacionIgv = this.especificacionIgv
                if(this.codigoProductoSunat != ''){
                    producto.codigoProductoSunat = this.codigoProductoSunat
                }
                if(this.codigoProductoGs1 != ''){
                    producto.codigoProductoGs1 = this.codigoProductoGs1
                }
                axios
            .post(process.env.VUE_APP_API_URL + 'productos/grabar',{
                token: this.$store.getters.userToken,
                producto
            })
            .then(response => (
                this.$snotify.success(response.data.msg, 'Éxito'),
                this.product = response.data,
                this.sendproducto = false,
                this.nuevoproducto = false,
                this.cleanProduct(),
                this.add = false,
                this.listProduct()
            ))
            .catch(error => (
                this.sendproducto = false,
                this.nuevoproducto = false,
                this.add = false,
                this.$snotify.error(error.response.data.msg, 'Error')
            ))
        },
    addItem(){
        let precioT = 0.0;
              let item = {
                idProducto:"",
                codigo:"",
                descripcion:this.descripcion,
                unidadMedida:this.unidadMedidaCantidad,
                cantidad:"",
                precioUnitario:"",
                igv:this.igv,
                valorTotal:this.valorTotal,
                precioVentaUnitario: "",  
                codigoProductoGs1:'',
                codigoProductoSunat:'',
                idCategoria:'',
                tipoAfectacionIgv:''
            }
            item.idProducto = this.idProducto
            item.codigo = this.codigoProducto
            item.cantidad = parseFloat(this.cantidadStock);
            item.codigoProductoGs1 = this.codigoProductoGs1;
            item.codigoProductoSunat = this.codigoProductoSunat;
            item.idCategoria = this.indexCategoria;
            item.tipoAfectacionIgv = this.tipoAfectacionIgv
            item.precioUnitario = parseFloat(this.precioUnitarioIGV);
            item.precioVentaUnitario = parseFloat(this.precioUnitarioIGV);
                this.baseAfectacionIgv = this.cantidadStock * this.precioUnitarioIGV
        if(this.tipoAfectacionIgv == "01"){
            if(this.precioUnitarioIGV !='' ){
                item.valorTotal = (this.baseAfectacionIgv / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(5);
                };
            if(this.precioUnitarioIGV !=''){
                item.igv = (item.valorTotal * (this.$store.state.igv == 18 ? 0.18 : 0.105)).toFixed(5);
                };
            if(this.precioUnitarioIGV!=''){
                 item.valorUnitario = (this.precioUnitarioIGV / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(5) ;     
                };
        }else if(this.tipoAfectacionIgv == "02" || this.tipoAfectacionIgv == "03"){
                    item.valorTotal = this.baseAfectacionIgv
                    item.igv = parseFloat(0.0);
                    item.valorUnitario = this.precioUnitarioIGV 
            }
        if(this.cantidadStock !=''){
                // item.precioTotal = parseFloat(parseFloat(item.valorTotal + item.igv).toFixed(2));
                item.precioTotal = this.cantidadStock * this.precioUnitarioIGV;
            };
            if(this.cantidadStock !='' && this.precioUnitarioIGV !=''){
                   this.precioTotal = this.cantidadStock * this.precioUnitarioIGV
                   this.cantidadS = this.cantidadStock
                   this.precioConIgv = this.precioUnitarioIGV
                   this.unidadM = this.unidadMedidaCantidad
                   this.description = this.descripcion

                };  
            if (this.setIndex != -1) {
                 Object.assign(this.items[this.setIndex], item);
                this.$snotify.warning("Item Actualizado Correctamente", "Atencion"),
                (this.setIndex = -1);
                (this.setUpdateItem = false), this.initItem()
            }else{
            if(this.descripcion !='' && this.cantidadStock != '' && this.precioUnitarioIGV !=''){
                if(this.codigoProducto !=''){
                    this.items.push(item);
                    this.initItem()
                }else{
                    this.$snotify.warning("Este producto no esta registrado")
                }
            }else{
                this.$snotify.warning("Completar todos los campos")
                } 
            }

        },
    initItem: function () {
                this.descripcion = '',
                this.cantidadStock= 1,
                this.precioUnitario= '',
                this.precioUnitarioIGV= '',
                this.unidadMedidaCantidad=''
        },
        cleanSend(){
            this.almacen = '',
            this.receptor.numero = '',
            this.receptor.razonSocial = '',
            this.receptor.direccion = '',
            this.fechaIngreso = '',
            this.fechaemision = '',
            this.fechavencimiento = '',
            this.tipodocingreso = 1 ,
            this.serie = this.listaSeries[this.indexSerie],
            this.numerodoc = '',
            this.moneda.codigo = this.tipoMoneda, 
            this.adicionaldoc = null,
            /*this.sumaValor = '',
            this.totaldscto = '',
            this.sumaValor = '',
            this.sumaIGV = '',
            this.total(),*/
            this.observaciones = '',
            this.items = [];
            this.initMoneda();
            this.file = null,
            this.action.reset = true,
            this.itemsEx = [],
            this.itemsAccepted = [],
            this.rechazados = []
        },
    deleteItem(index) {
                this.items.splice(index,1)
         },
    updateItem: function(index, itemUpdate) {
                let itemChange = itemUpdate;
                let item = {};
                this.setUpdateItem = true;
                this.setIndex = index;
                this.cantidadStock = itemChange.cantidad;
                this.unidadMedidaCantidad = itemChange.unidadMedida;
                this.descripcion = itemChange.descripcion;
                this.precioUnitarioIGV = itemChange.precioVentaUnitario;
                this.idProducto = itemChange.idProducto;
                this.codigoProducto = itemChange.codigo;
                this.tipoAfectacionIgv = itemChange.tipoAfectacionIgv;
                this.codigoProductoGs1 = itemChange.codigoProductoGs1
                this.codigoProductoSunat = itemChange.codigoProductoSunat
                this.indexCategoria = itemChange.idCategoria
        },    
    executeUpdate() {
                this.addItem();
        },
    initMoneda: function() {
            this.moneda = {
            id: "1",
            codigo: "PEN",
            descripcion: "SOLES",
            simbolo: "S/."
            };
        },
    valortotal(){
                let val = 0.0;
                this.items.forEach(function(element){
                    if(element.valorTotal !=''){
                         val += parseFloat(element.valorTotal);
                    }
                })
                return val;
         },

    totalesIGV(){
                let val = 0.0;
                this.items.forEach(function(element){
                    if(element.igv !=''){
                        val += parseFloat(element.igv);
                    }
                })
                return val;
                }, 
         
    total(){
                let val = 0.0;
                    if(this.valortotal() != 0 || this.totalesIGV() != 0){
                        this.sumaIGV = this.totalesIGV();
                        this.sumaValor = this.valortotal();
                        val = parseFloat(this.sumaIGV + this.sumaValor).toFixed(2)
                    }
                    return val;
         },
    tipodocumento(){
                let  val = this.tipodocingreso
                    if(this.selected == 1){
                        this.tipodocingreso = 'Factura'
                    }else if(this.selected == 2){
                        this.tipodocingreso = 'Boleta'
                    }
                    return val;     
         },
    validarMercaderia(){
        if(this.tipoDocumento2 == 0){
            if(this.serie !='' &&  
                this.numerodoc !='' &&
                this.fechaIngreso !='' &&
                this.fechaemision !='' &&
                this.fechavencimiento !='' &&
                this.items.length>0) {
                    this.addMercaderia();
            }else{
                this.$snotify.warning("Completar todos los campos","Cuidado")
            }
        }else if(this.tipoDocumento2 == 6){
                if(this.receptor.numero !='' && 
                    this.receptor.razonSocial !='' && 
                    this.serie !='' && 
                    this.numerodoc !='' &&
                    this.fechaIngreso !='' &&
                    this.fechaemision !='' &&
                    this.fechavencimiento !='' &&
                    this.receptor.direccion !='' &&
                    this.items.length>0){
                        this.addMercaderia();
                }else{
                    this.$snotify.warning("Completar todos los campos","Cuidado")
                }
            }    
    },
    addMercaderia(){
            this.entrada.token = this.$store.getters.userToken
            this.entrada.almacen = this.almacen
            if(this.tipoDocumento2 == 0){
                this.entrada.rucproveedor = "no especifica"
                    if(this.receptor.razonSocial !=''){
                        this.entrada.rsproveedor = this.receptor.razonSocial
                    }else{
                        this.entrada.rsproveedor = "no especifica"
                    };
                    // 
                    if(this.receptor.direccion !=''){
                         this.entrada.direcproveedor =  this.receptor.direccion
                    }else{
                        this.entrada.direcproveedor = "no especifica"
                    }

            }else{
                this.entrada.rucproveedor = this.receptor.numero,
                this.entrada.rsproveedor =  this.receptor.razonSocial,
                this.entrada.direcproveedor =  this.receptor.direccion
            }
            this.entrada.fechaingreso =  this.$moment(this.fechaIngreso).format("YYYY-MM-DD HH:mm:ss"),
            this.entrada.fechaemisiondoc =  this.$moment(this.fechaemision).format("YYYY-MM-DD HH:mm:ss"),
            this.entrada.fechavencimiento =  this.$moment(this.fechavencimiento).format("YYYY-MM-DD HH:mm:ss"),
            this.entrada.tipodocingreso = this.tipodocingreso,
            this.entrada.seriedoc = this.serie,
            this.entrada.numerodoc = this.numerodoc,
            this.entrada.moneda = this.moneda.codigo,
            this.entrada.adicionaldoc = this.adicionaldoc,
            this.entrada.totalbruto = this.sumaValor,
            this.entrada.totaldscto = this.totaldscto,
            this.entrada.subtotal = this.sumaValor,
            this.entrada.igv = this.sumaIGV,
            this.entrada.total = this.total(),
            this.entrada.observaciones = this.observaciones,
            this.entrada.items = this.items
            this.entrada.adicional.tipo_igv = this.igvGlobal

                axios.post(process.env.VUE_APP_API_URL + "entrada/ingreso",this.entrada)
            .then(response =>(
                    this.info = response.data,
                    this.$snotify.success(response.data.msg, "Exito"),
                    this.initItem(),
                    this.cleanSend(),
                    this.getlistado()            
                ))
            .catch(error=>(
                    this.$snotify.error(error.response.data,"Error")
                ))
    },
    initDates: function() {
                let r1 = {
                    from: this.$moment().subtract(50000, "years"),
                    to: this.$moment().subtract(8, "days")
        };
                let r2 = {
                    from: this.$moment().add(0, "days"),
                    to: this.$moment().add(60000, "years")
        };
                    this.diasnopermitidos.ranges.push(r1);
                    this.diasnopermitidos.ranges.push(r2);
      },


    getlistado(){
    this.cargando = true;
        axios.post(process.env.VUE_APP_API_URL + 'entrada/listar',{
            token: this.$store.getters.userToken,
            page:  this.paginaActual,
            limit: this.limite,
            order: this.orden
        })
        .then(response =>(
            this.listado = response.data.data,           
            this.desde = response.data.from,
            this.hasta = response.data.to,
            this.totalList = response.data.total,
            this.cargando = false
        ))
        .catch(error => {
            this.$snotify.error(error.response.data.response.message, "Error");
        })
    },
 /*Eliminar Mercaderia*/
    deleteEntrada(value){
          axios.
          post(process.env.VUE_APP_API_URL + "entrada/eliminar",{
            token: this.$store.getters.userToken,
            identrada: value
          })
          .then(response => ( 
            this.$snotify.success(response.data.msg, "Éxito"),
            this.getlistado()
          ))
          .catch(error=>(
            this.$snotify.error(error.response.data,"Error")
          ))              
      },
    crear(){
          this.verCrear = false;
      },
    listaver(){
        this.verCrear = true;
      },
    subirItems(){
        let formData = new FormData();
        formData.append("token",this.$store.getters.userToken);
        formData.append("productos",this.file); 
        axios
        .post(process.env.VUE_APP_API_URL + "entrada/productos",
            formData,
            {
                responseType: "json",
                    headers: {"Content-Type": "multipart/form-data"}
            })
        .then(response=>(
            this.itemsAccepted = response.data.productos,
            this.rechazados = response.data.noencontrados,
            this.productosExcel(),
            this.file = null
        ))
        .catch(error=>(
            this.$swal({
                title: 'Error al cargar documento',
                text: 'Revisar que el documento de Excel este rellenado correctamente',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    this.file = null
                }
            })   
        ))
    },
    productosExcel(){
        if(this.itemsAccepted !=''){                   
            this.itemsEx = this.itemsAccepted
            this.action.i = true                  
        }
    },
    mostrarItemsRechazados(){
        this.itemsRechazados = true
    },
    cerrarItems(){
        this.itemsRechazados = false
    },
    }
}
</script>

<style lang="scss" scoped>
    .contenedor{
        text-align:left;
    }
    .buscarRuc{
        margin-top: -50px;
    }
    .searcher-field{
        margin-top: 35px;
        z-index: 1000;
        position: absolute;
        max-height: 400px !important;
        overflow-y: scroll;
        width: 500px;
    }
    .searcher-fieldPro{
        z-index: 1000;
        position: absolute;
        max-height: 400px !important;
        overflow-y: scroll;
        width: 500px;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .searcher-result{
        font-size: smaller;
        padding: 2px 0px 2px 0px;
        cursor: pointer;
    }

    .mover{
        width: 10px;
        margin-left:-24px;
    }
    .sinresultados{
        padding: 0 5px 0 5px;  
    }
    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }   
    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .estilo {
        border: 2px solid teal;
        color: white;
        background-color: teal;
        padding: 8px 20px;
        border-radius: 5px;
        font-weight: bold;
    }
    .wrapper{
    width:100%;
    height:100%;
    // background-color: aqua;
    // display:flex;
    // align-items:center;
    // justify-content:center;
    // float: right;
    .file-upload{
        margin-bottom: 20px;
        height:45px;
        width:100%;
        border-radius: 10px;
        position:relative;
        display:flex;
        justify-content:center;
        align-items: center;  
        border:4px solid #E4E4E6;
        overflow:hidden;
        background-image: linear-gradient(to bottom, teal 50%, #E4E4E6 50%);
        background-size: 100% 200%;
        transition: all 1s;
        color: #FFFFFF;
        font-size:16px;
        input[type='file']{
        height:220px;
        width:200px;
        position:absolute;
        top:0;
        left:0;
        opacity:0;
        cursor:pointer;
        }
        &:hover{
        background-position: 0 -100%;
        color:black;
        }
    }
}
</style>